import type { default as JobInfoJson } from "./json/JobInfo.api.json";

export type JobInfoApiData = typeof JobInfoJson;

export class JobInfo {
    constructor(data: JobInfoApiData) {
        this.id = data.id;
        this.name = data.name;
        this.builderId = data.builderId;
        this.jobStatus = data.jobStatus;
        this.ownerName = data.ownerName;
        this.portal = data.portal;
        this.userId = data.userId;
        this.canView = data.canView;
        this.isSelectionsReimaginedJob = data.isSelectionsReimaginedJob ?? false;
    }

    id: number;
    name: string;
    builderId: number;
    jobStatus: number;
    ownerName?: string;
    portal?: string | null;
    userId: number;
    canView: boolean;
    isSelectionsReimaginedJob?: boolean;
}
